'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./experience/components/blogListing'));
    processInclude(require('./experience/components/blogHeroCarousel'));
    processInclude(require('./experience/components/formWithVideo'));
});
